import { ReactNode } from 'react'

import watermarkUrl from '@/assets/ahstc-logo.svg?url'
import { cn } from '@/lib/utils'

import '@/styles/report-layout.css'

export interface ReportLayoutProps {
  children: ReactNode
  className?: string
  header?: ReactNode
  showWatermark?: boolean
}

export function ReportLayout({
  children,
  className,
  header,
  showWatermark = true,
}: ReportLayoutProps) {
  return (
    <div
      className={cn('report-layout', !showWatermark && 'report-layout--no-watermark', className)}
    >
      {showWatermark ? (
        <div className="report-layout__watermark" aria-hidden="true">
          <img src={watermarkUrl} alt="" data-testid="report-watermark" />
        </div>
      ) : null}

      {header ? <header className="report-layout__header">{header}</header> : null}

      <main className="report-layout__body">{children}</main>
    </div>
  )
}
